import { render, staticRenderFns } from "./EmployerSalary.vue?vue&type=template&id=a71911c0&"
import script from "./EmployerSalary.vue?vue&type=script&lang=js&"
export * from "./EmployerSalary.vue?vue&type=script&lang=js&"
import style0 from "./EmployerSalary.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/projects/accurate/acc-dashboard/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlideXReverseTransition } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VContainer,VDataTable,VFlex,VLayout,VSlideXReverseTransition})
